import { CDK_USER_TYPES } from '@/enums';
import { OriginalUserDataType } from '@/types';
import { jwtDecode } from 'jwt-decode';

export const checkIfUserIsAllowedToUseCDK = () => {
  const user = jwtDecode(localStorage.getItem('accessToken') as string) as OriginalUserDataType;
  if (CDK_USER_TYPES.includes(user.type)) {
    return;
  } else {
    redirectToLoginInHub();
  }
};

export const redirectToLoginInHub = () => {
  window.location.href = `${import.meta.env.VITE_HUB_URL}`;
};
